import { render, staticRenderFns } from "./CommodityVarietyRemoteAutocomplete.vue?vue&type=template&id=203eb100"
import script from "./CommodityVarietyRemoteAutocomplete.vue?vue&type=script&lang=js"
export * from "./CommodityVarietyRemoteAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports